__turbopack_context__.v({
  "actionButton": "styles-module-scss-module__G1lJCq__actionButton",
  "closeButton": "styles-module-scss-module__G1lJCq__closeButton",
  "fadeIn": "styles-module-scss-module__G1lJCq__fadeIn",
  "footerText": "styles-module-scss-module__G1lJCq__footerText",
  "heading": "styles-module-scss-module__G1lJCq__heading",
  "icon": "styles-module-scss-module__G1lJCq__icon",
  "iconContainer": "styles-module-scss-module__G1lJCq__iconContainer",
  "iconWrapper": "styles-module-scss-module__G1lJCq__iconWrapper",
  "infoBox": "styles-module-scss-module__G1lJCq__infoBox",
  "infoBoxText": "styles-module-scss-module__G1lJCq__infoBoxText",
  "modal": "styles-module-scss-module__G1lJCq__modal",
  "modalContent": "styles-module-scss-module__G1lJCq__modalContent",
  "modalOverlay": "styles-module-scss-module__G1lJCq__modalOverlay",
  "scaleIn": "styles-module-scss-module__G1lJCq__scaleIn",
});
